import Logo from "../assets/logo1.svg";
import { ReactComponent as Lia } from "../assets/lia-talk.svg";
import { ReactComponent as BankExercises } from "../assets/bank-exercises.svg";
import { ReactComponent as CoffeeMachine } from "../assets/cafeteira.svg";
import { ReactComponent as MedicalRecord } from "../assets/iamedicalrecord.svg";
import { Link } from "react-router-dom";
import { useEffect } from "react";

export default function Home() {
  useEffect(() => {
    document.title = "Início - Sonafe 2025";
  }, []);

  return (
    <main className="min-h-screen pt-6 flex flex-col items-center justify-start  bg-white text-default">
      <div className="w-full max-w-[720px] flex flex-col items-center">
        <header className="w-full px-6 flex items-center justify-center mb-8">
          <img
            src={Logo}
            alt="ScalLogo"
            className="w-40 sm:w-48 md:w-56 h-auto object-contain"
          />
        </header>

        <section className="w-full px-6 flex flex-col  gap-3 ">
          <span className="text-3xl sm:text-4xl font-museo text-default leading-tight">
            🎉 Bem-vindo ao <span className="font-bold">SONAFE 2025</span> e ao
            universo do Scal!
          </span>

          <span className="text-default font-funnel sm:text-lg">
            Você está em um dos maiores eventos de fisioterapia do Brasil e a
            gente veio preparado para fazer essa experiência inesquecível.
          </span>

          <span className="text-default font-funnel mt-4  sm:text-lg">
            Descubra tudo o que preparamos no nosso stand!
          </span>
        </section>

        <section className="my-10 w-full px-6 flex flex-col items-center justify-center gap-6">
          <Link to="/sorteio" className="w-full cursor-pointer">
            <CoffeeMachine className="w-full h-auto object-contain" />
          </Link>
          <Link
            target="_blank"
            rel="noopener noreferrer"
            to="https://api.whatsapp.com/send/?phone=558581140690&text&type=phone_number&app_absent=0"
            className="w-full cursor-pointer"
          >
            <Lia className="w-full h-auto object-contain" />
          </Link>
          <Link to="/prontuario" className="w-full cursor-pointer">
            <MedicalRecord className="w-full h-auto object-contain" />
          </Link>
          <Link
            target="_blank"
            rel="noopener noreferrer"
            to="https://wa.me/5511918564424?text=Quero entender melhor sobre o recurso do banco de exercícios."
            className="w-full cursor-pointer"
          >
            <BankExercises className="w-full h-auto object-contain" />
          </Link>
        </section>

        <footer className="bg-[#F5F5F5] w-full h-40 mt-16 flex items-center justify-center">
          <img src={Logo} alt="ScalLogo" className="" />
        </footer>
      </div>
    </main>
  );
}
